<script>
  import { onMount } from "svelte";

  onMount(async () => {
    console.log("Create a new ACL App")
  });
</script>

<div class="container-xl">
  <div class="row">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">New app</h3>
        </div>
        <div class="card-body">
          <div class="mb-3">
            New App
          </div>
        </div>

        <div class="card-footer text-end">
          <button type="submit" class="btn btn-primary">New</button>
        </div>
      </div>
    </div>
  </div>
</div>